import { render, staticRenderFns } from "./Declaracoes.vue?vue&type=template&id=c14e7df2&"
import script from "./Declaracoes.vue?vue&type=script&lang=js&"
export * from "./Declaracoes.vue?vue&type=script&lang=js&"
import style0 from "./Declaracoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports